import React, {Component} from "react";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import ActionButton from "../../../components/ActionButton";
import {GET_CLIENT_DISPATCH, ON_CLIENT_DISPATCH_UPDATED} from "../../../queries/clientDispatches";
import SerialNumbersButton from "../../serialNumbers/SerialNumbersButton";
import WarningBanner from "../../../components/WarningBanner";
import {WarehousePlace, AddressPlace, Place} from "../../shared/Places";
import {requestRemovePalletFromClientDispatch} from "../../../actions/ClientDispatchApiActions";
// Shares the transfer details' layout.
import "../../stockTransfers/views/StockTransferDetails.scss";

class ClientDispatchDetails extends Component {

  componentDidMount() {
    const {data} = this.props;
    this.unsubscribe = data.subscribeToMore({
      document: ON_CLIENT_DISPATCH_UPDATED,
      updateQuery: (prev) => {
        data.refetch();
        return prev;
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const {loading, error, clientDispatch} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    if (!clientDispatch) return <p>Dispatch not found</p>

    const dispatch = fromJS(clientDispatch);
    const isDraft = dispatch.get("status") === "draft";

    return (
      <div className="StockTransferDetails ClientDispatchDetails">
        <WarningBanner show={!!dispatch.get("notes")} error={false} message={`Note: ${dispatch.get("notes")}`} />
        <div className="overview section">
          <WarehousePlace title="Ship from" warehouseId={dispatch.get("originWarehouseId")} />
          <AddressPlace title="Ship to" name={dispatch.get("partnerName")} address={clientDispatch.deliveryAddress} />
          <Place
            title="References"
            name={dispatch.get("reference") ? `Client: ${dispatch.get("reference")}` : "No client reference"}
            lines={[
              dispatch.get("carrierReference") ? `Carrier: ${dispatch.get("carrierReference")}` : "",
              dispatch.get("stordOrderNumber") ? `Stord order: ${dispatch.get("stordOrderNumber")}` : "",
              dispatch.get("dispatchDate") ? `Dispatch date ${String(dispatch.get("dispatchDate")).substr(0, 10)}` : "",
            ]} />
        </div>
        <div className="section">
          <h4>Pallets &amp; Lines</h4>
          {this.renderLines(dispatch.get("lines", List()), isDraft)}
        </div>
      </div>
    )
  }

  renderLines(lines, isDraft) {
    // Water units whose serial number is not on the dispatch yet.
    const missingSerials = (line) => String(line.get("sku") || "").startsWith("WAT-")
      ? Math.max(line.get("quantity", 0) - line.get("serialNrs", List()).size, 0)
      : 0;

    if (lines.size === 0) {
      return <p className="empty">No pallets have been added yet.</p>
    }

    const byPallet = lines.groupBy((line) => line.get("palletId"));

    return byPallet.entrySeq().toArray().map(([palletId, palletLines]) => (
      <div className="palletGroup" key={palletId}>
        <div className="palletHeader">
          <span className="palletId">Pallet {palletId}</span>
          <span className="palletMeta">{palletLines.getIn([0, "kind"])}</span>
          {isDraft &&
            <ActionButton label="Remove" primary={false}
              onClick={() => this.props.requestRemovePalletFromClientDispatch(this.props.clientDispatchId, palletId)} />}
        </div>
        <table className="linesTable">
          <thead>
            <tr><th>SKU</th><th>Qty</th><th>Serials</th></tr>
          </thead>
          <tbody>
            {palletLines.map((line, i) => (
              <tr key={line.get("id", i)}>
                <td>{line.get("sku")}</td>
                <td>{line.get("quantity")}</td>
                <td>
                  <SerialNumbersButton serialNrs={line.get("serialNrs")} title={`Pallet ${palletId} · ${line.get("sku")}`} />
                  {missingSerials(line) > 0 && <span className="missingSerials"> {missingSerials(line)} missing</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ))
  }
}

const withQuery = graphql(GET_CLIENT_DISPATCH, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {id: props.clientDispatchId},
  }),
  skip: (props) => !props.clientDispatchId,
});

export default withQuery(connect(null, {requestRemovePalletFromClientDispatch})(ClientDispatchDetails));
